
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faSquare as falSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
    import { faCheckSquare as fasCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
    import { faSquare as farSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
    import C1TagAdd from '@/C1Components/C1TagAdd';

    export default {
        name: 'C1Tags',

        components: {
            C1TagAdd,
            FontAwesomeIcon,
        },

        props: {
            value: {
                type: [Array, Object],
                default: () => [],
            },

            tagKey: {
                type: String,
                default: 'id',
            },

            tagLabelKey: {
                type: String,
                default: 'label',
            },

            tagUppercase: {
                type: Boolean,
                default: false,
            },

            toggleLabel: {
                type: String,
                default: 'Select all',
            },

            options: {
                type: Array,
                default: () => [],
            },

            isSingleSelect: {
                type: Boolean,
                default: false,
            },

            isStacked: {
                type: Boolean,
                default: false,
            },

            hideHeader: {
                type: Boolean,
                default: false,
            },

            useLabelSlot: {
                type: Boolean,
                default: false,
            },

            toggleAll: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                icons: {
                    fasCheckSquare,
                    farSquare,
                    falSquare,
                },
            };
        },

        computed: {
            isAllSelected: {
                get() {
                    return this.value.length === this.options.length;
                },

                set(value) {
                    this.toggleAllTags(value);
                },
            },

            isNoneSelected() {
                return this.value.length <= 0;
            },
        },

        methods: {
            toggleSelect(tag, isSelected) {
                if (this.isSingleSelect) {
                    this.selectSingle(tag, isSelected);
                } else {
                    this.selectMultiple(tag, isSelected);
                }
            },

            selectSingle(tag, isSelected) {
                this.emitTags(isSelected ? tag : {});
            },

            selectMultiple(tag, isSelected) {
                const selectedTags = JSON.parse(JSON.stringify(this.value));
                if (isSelected) {
                    const existingTag = selectedTags.find(o => o[this.tagKey] === tag[this.tagKey]);
                    if (!existingTag) {
                        selectedTags.push(tag);
                    }
                } else {
                    const tagIndex = selectedTags.findIndex(o => o[this.tagKey] === tag[this.tagKey]);
                    selectedTags.splice(tagIndex, 1);
                }
                this.emitTags(selectedTags);
            },

            toggleAllTags(value) {
                let output = [];
                if (value) {
                    output = this.options;
                }
                this.emitTags(output);
            },

            toggleSelectAll() {
                const toggleValue = this.isAllSelected;
                this.toggleAllTags(!toggleValue);
            },

            isTagSelected(tag) {
                if (this.isSingleSelect) {
                    return this.value[this.tagKey] === tag[this.tagKey];
                } else {
                    return !!this.value.find(o => o[this.tagKey] === tag[this.tagKey]);
                }
            },

            emitTags(tags) {
                this.$emit('input', tags);
            },
        },
    };
